import React from "react";
import MainSelect from "components/MainSelect/MainSelect.view";
import { useStyles } from "./RCAAPComplianceByResponsibleFilter.styles";
import { RCAAPComplianceByResponsibleFilterEnum } from "../../../RCAAPComplianceInterfaces";
import useRCAAPComplianceByResponsibleFilter from "./useRCAAPComplianceByResponsibleFilters";
import { IRCAAPComplianceByResponsibleFiltersProps } from "./RCAAPComplianceByResponsibleFilterInterfaces";

const rcaApComplianceByResponsibleValues = Object.values(RCAAPComplianceByResponsibleFilterEnum);

const RCAAPComplianceByResponsibleFilter = ({ filters, setFilters }: IRCAAPComplianceByResponsibleFiltersProps) => {
    const classes = useStyles();

    const { rcaComplianceByResponsibleOptions } = useRCAAPComplianceByResponsibleFilter({
        rcaApComplianceByResponsibleOptions: rcaApComplianceByResponsibleValues,
    });

    return (
        <div className={classes.select}>
            <MainSelect
                fullWidth={false}
                multiple={false}
                value={filters.typeOption}
                options={rcaComplianceByResponsibleOptions || []}
                onChange={(e) => setFilters(e.target.value as string)}
            />
        </div>
    );
};

export default RCAAPComplianceByResponsibleFilter;
